import React from 'react'

export const RowPrimitive = ({children, useRef, onLayout, ...props}) => {
    return <div style={props} ref={useRef}>{children}</div>
}